import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'tool-form',
  templateUrl: './tool-form.component.html',
  styleUrl: './tool-form.component.css',
  standalone: false,
})
export class ToolFormComponent {
  @Input({ required: true }) formTitle!: string;

  public env = environment;
}
